import { Component, AfterViewInit, Input, Injector } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { MatFormFieldControl, MatFormField } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";

import { FormErrorMessages } from "../utilities/forms";

@Component({
  selector: "[form-error-list]",
  template: '<span *ngFor="let err of errors"> {{ messages[err] || messages.default }} </span>',
})
export class FormErrorListComponent implements AfterViewInit {
  @Input("form-error-list") custom_messages: any = {};

  errors = [];
  messages = {
    required: FormErrorMessages.required,
    pattern: FormErrorMessages.pattern,
    default: FormErrorMessages.generic,
  };

  private inputRef: MatFormFieldControl<MatInput>;

  constructor(private _inj: Injector) {}

  public ngAfterViewInit() {
    Object.assign(this.messages, this.custom_messages);

    // grab reference to MatFormField directive, where form control is accessible.
    let container = this._inj.get(MatFormField);
    this.inputRef = container._control;

    // sub to the control's status stream
    this.inputRef.ngControl.statusChanges.subscribe(this.updateErrors);
  }

  private updateErrors = (state: "VALID" | "INVALID") => {
    this.errors = Object.keys(this.inputRef.ngControl.errors || []);
  };
}
